<form (ngSubmit)="search()" style="width: 100%">
  <div class="ui-g filterPanel form-group">
    <div class="ui-g-12 ui-md-4 ui-lg-2">
      <span class="md-inputfield filterItem">
        <input name="regNo" type="text" pInputText [(ngModel)]="regNo" />
        <label>Reg.No.</label>
      </span>
    </div>
    <div class="ui-g-12 ui-md-4 ui-lg-2">
      <span class="md-inputfield filterItem">
        <input name="from" type="text" pInputText [(ngModel)]="from" />
        <label>From Location</label>
      </span>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-2">
      <span class="md-inputfield filterItem">
        <input name="to" type="text" pInputText [(ngModel)]="to" />
        <label>To Location</label>
      </span>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-2" *ngIf="inboxType == inboxType_VmeInbox">
      <p-dropdown
        name="customers"
        [options]="customers"
        [(ngModel)]="filterVal.filters.customerId.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
      ></p-dropdown>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-2" *ngIf="inboxType == inboxType_VmeInbox">
      <p-dropdown
        name="suppliers"
        [options]="suppliers"
        [(ngModel)]="filterVal.filters.supplierId.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
      ></p-dropdown>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-2">
      <p-dropdown
        name="taskType"
        [options]="taskTypes"
        [(ngModel)]="filterVal.filters.taskType.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
      ></p-dropdown>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-2" *ngIf="inboxType == inboxType_VmeInbox">
      <p-dropdown
        name="eregions"
        [options]="eregions"
        [(ngModel)]="filterVal.filters.eregionId.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
      ></p-dropdown>
    </div>

    <div class="ui-g-12 ui-md-4 ui-lg-8">
      <button pButton type="submit" label="Search"></button>
      <button pButton type="button" label="Clear" (click)="clearFilter()"></button>
    </div>
  </div>
</form>

<div class="ui-g tasks-live-container">
  <div class="ui-g-12">
    <div style="margin-left: 5px; margin-right: 5px; border: 1px solid lightgrey">
      <map-control
        [tasks]="taskList"
        [(selectedTask)]="selectedTask"
        [origin]="selectedTask ? selectedTask.pickupLocation : null"
        [destination]="selectedTask ? selectedTask.dropoffLocation : null"
        [readOnly]="true"
      ></map-control>
    </div>
  </div>
</div>
